import * as React from "react";
import {
  Button as FluentUIButton,
  ButtonProps as FluentUIButtonProps,
} from "@fluentui/react-components";

type IIconButton = FluentUIButtonProps & {
  icon: React.ReactNode;
  ariaLabel: string;
};

export const IconButton: React.FC<IIconButton> = ({
  icon,
  ariaLabel,
  appearance = "subtle",
  shape = "circular",
  size = "medium",
  ...rest
}) => {
  return (
    <FluentUIButton
      icon={icon}
      aria-label={ariaLabel}
      appearance={appearance}
      shape={shape}
      size={size}
      {...rest}
    />
  );
};
